var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import flatpickr from 'flatpickr';
import rangePlugin from 'flatpickr/dist/plugins/rangePlugin';
import DatePickerInput from '../DatePickerInput';

// Weekdays shorthand for english locale
flatpickr.l10ns.en.weekdays.shorthand.forEach(function (day, index) {
  var currentDay = flatpickr.l10ns.en.weekdays.shorthand;
  if (currentDay[index] === 'Thu' || currentDay[index] === 'Th') {
    currentDay[index] = 'Th';
  } else {
    currentDay[index] = currentDay[index].charAt(0);
  }
});

var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.addKeyboardEvents = function (cal) {
      var input = _this.inputField;
      input.addEventListener('keydown', function (e) {
        if (e.which === 40) {
          cal.calendarContainer.focus();
        }
      });
      if (_this.toInputField) {
        _this.toInputField.addEventListener('blur', function () {
          _this.cal.close();
        });
      }
    }, _this.openCalendar = function () {
      _this.cal.open();
    }, _this.updateClassNames = function (calendar) {
      var calendarContainer = calendar.calendarContainer;
      var daysContainer = calendar.days;
      calendarContainer.classList.add('bx--date-picker__calendar');
      calendarContainer.querySelector('.flatpickr-month').classList.add('bx--date-picker__month');
      calendarContainer.querySelector('.flatpickr-weekdays').classList.add('bx--date-picker__weekdays');
      calendarContainer.querySelector('.flatpickr-days').classList.add('bx--date-picker__days');
      [].concat(_toConsumableArray(calendarContainer.querySelectorAll('.flatpickr-weekday'))).forEach(function (item) {
        var currentItem = item;
        currentItem.innerHTML = currentItem.innerHTML.replace(/\s+/g, '');
        currentItem.classList.add('bx--date-picker__weekday');
      });
      [].concat(_toConsumableArray(daysContainer.querySelectorAll('.flatpickr-day'))).forEach(function (item) {
        item.classList.add('bx--date-picker__day');
        if (item.classList.contains('today') && calendar.selectedDates.length > 0) {
          item.classList.add('no-border');
        } else if (item.classList.contains('today') && calendar.selectedDates.length === 0) {
          item.classList.remove('no-border');
        }
      });
    }, _this.assignInputFieldRef = function (node) {
      _this.inputField = !node ? null : // Child is a regular DOM node, seen in tests
      node.nodeType === Node.ELEMENT_NODE ? node.querySelector('.bx--date-picker__input') : // Child is a React component
      node.input && node.input.nodeType === Node.ELEMENT_NODE ? node.input : null;
    }, _this.assignToInputFieldRef = function (node) {
      _this.toInputField = !node ? null : // Child is a regular DOM node, seen in tests
      node.nodeType === Node.ELEMENT_NODE ? node.querySelector('.bx--date-picker__input') : // Child is a React component
      node.input && node.input.nodeType === Node.ELEMENT_NODE ? node.input : null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DatePicker, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (nextProps.value !== this.props.value) {
        if (this.props.datePickerType === 'single' || this.props.datePickerType === 'range') {
          this.cal.setDate(nextProps.value);
          this.updateClassNames(this.cal);
        } else {
          if (this.inputField) {
            this.inputField.value = nextProps.value;
          }
        }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.datePickerType === 'single' || this.props.datePickerType === 'range') {
        this.cal = flatpickr(this.inputField, {
          mode: this.props.datePickerType,
          allowInput: true,
          dateFormat: this.props.dateFormat,
          plugins: this.props.datePickerType === 'range' ? [new rangePlugin({ input: this.toInputField })] : '',
          clickOpens: true,
          onChange: function onChange() {
            _this2.props.onChange();
          },
          onReady: function onReady(selectedDates, dateStr, instance) {
            _this2.updateClassNames(instance);
          },
          nextArrow: this.rightArrowHTML(),
          leftArrow: this.leftArrowHTML()
        });
        this.addKeyboardEvents(this.cal);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.datePickerType === 'range' || this.props.datePickerType === 'single') {
        this.cal.destroy();
      }
    }
  }, {
    key: 'rightArrowHTML',
    value: function rightArrowHTML() {
      return '\n      <svg width="8" height="12" viewBox="0 0 8 12" fill-rule="evenodd">\n        <path d="M0 10.6L4.7 6 0 1.4 1.4 0l6.1 6-6.1 6z"></path>\n      </svg>';
    }
  }, {
    key: 'leftArrowHTML',
    value: function leftArrowHTML() {
      return '\n      <svg width="8" height="12" viewBox="0 0 8 12" fill-rule="evenodd">\n        <path d="M7.5 10.6L2.8 6l4.7-4.6L6.1 0 0 6l6.1 6z"></path>\n      </svg>';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          short = _props.short,
          datePickerType = _props.datePickerType,
          dateFormat = _props.dateFormat,
          other = _objectWithoutProperties(_props, ['children', 'className', 'short', 'datePickerType', 'dateFormat']);

      var datePickerClasses = classNames('bx--date-picker', className, {
        'bx--date-picker--short': short,
        'bx--date-picker--simple': datePickerType === 'simple',
        'bx--date-picker--single': datePickerType === 'single',
        'bx--date-picker--range': datePickerType === 'range'
      });

      var datePickerIcon = datePickerType === 'range' ? React.createElement(
        'svg',
        {
          onClick: this.openCalendar,
          className: 'bx--date-picker__icon',
          width: '17',
          height: '19',
          viewBox: '0 0 17 19' },
        React.createElement('path', { d: 'M12 0h2v2.7h-2zM3 0h2v2.7H3z' }),
        React.createElement('path', { d: 'M0 2v17h17V2H0zm15 15H2V7h13v10z' }),
        React.createElement('path', { d: 'M9.9 15H8.6v-3.9H7.1v-.9c.9 0 1.7-.3 1.8-1.2h1v6z' })
      ) : '';

      var childArray = React.Children.toArray(children);
      var childrenWithProps = childArray.map(function (child, index) {
        if (index === 0 && child.type === DatePickerInput) {
          return React.cloneElement(child, {
            datePickerType: datePickerType,
            ref: _this3.assignInputFieldRef
          });
        } else if (index === 1 && child.type === DatePickerInput) {
          return React.cloneElement(child, {
            datePickerType: datePickerType,
            ref: _this3.assignToInputFieldRef
          });
        } else if (index === 0) {
          return React.cloneElement(child, {
            ref: _this3.assignInputFieldRef
          });
        } else if (index === 1) {
          return React.cloneElement(child, {
            ref: _this3.assignToInputFieldRef
          });
        }
      });
      return React.createElement(
        'div',
        { className: 'bx--form-item' },
        React.createElement(
          'div',
          _extends({ className: datePickerClasses }, other),
          childrenWithProps,
          datePickerIcon
        )
      );
    }
  }]);

  return DatePicker;
}(Component);

DatePicker.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  short: PropTypes.bool,
  datePickerType: PropTypes.string,
  dateFormat: PropTypes.string,
  value: PropTypes.string
};
DatePicker.defaultProps = {
  short: false,
  dateFormat: 'm/d/Y'
};
export default DatePicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/DatePicker/DatePicker.js
// module id = 308
// module chunks = 0